export default __webpack_public_path__ + "static/media/stylefmt.6cbc9da2.svg";